import { UpdatePasswordPayload, UpdatePasswordResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../services/core-api-service";

class UpdatePasswordService {
    public async updatePassword(payload: UpdatePasswordPayload): Promise<UpdatePasswordResult> {
        return api.auth.updatePassword(payload);
    }
}

export const service = new UpdatePasswordService();